module.exports = __webpack_public_path__ + "static/sport/btn-login.486b6cb.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/euro/btn-login.gif
// module id = r4rN
// module chunks = 0